export const TempSearchPageTypeList = [
  {label: '---', value: ''},
  {label: 'カバー', value: 'cover'},
  {label: 'トップ', value: 'top'},
  {label: '本身', value: 'page'},
  {label: 'エンド', value: 'end'}
] as const;
